import React, { useMemo } from 'react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { OktaConfig } from './config';

interface OktaProviderProps {
    children: React.ReactNode;
    config: OktaConfig;
    onRestoreOriginalUri?: (oktaAuth: OktaAuth, originalUri: string) => Promise<void>;
    oktaAuth?: OktaAuth;
}

export const OktaProvider: React.FC<OktaProviderProps> = ({
    children,
    config,
    onRestoreOriginalUri,
    oktaAuth: externalOktaAuth
}) => {
    const oktaAuth = useMemo(() => {
        if (externalOktaAuth) return externalOktaAuth;
        return new OktaAuth(config);
    }, [config, externalOktaAuth]);

    const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
        if (onRestoreOriginalUri) {
            await onRestoreOriginalUri(_oktaAuth, originalUri);
        } else {
            window.location.replace(toRelativeUrl(originalUri || '/', window.location.origin));
        }
    };

    if (config.disableAuth) {
        return <>{children}</>;
    }

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            {children}
        </Security>
    );
};
